import { memo } from 'react';
import { tv, type VariantProps } from 'tailwind-variants';
import { ReactSVG, Props as ReactSVGProps } from 'react-svg';

const icon = tv({
  base: 'inline-block transition-colors duration-300',
  variants: {
    size: {
      xs: 'w-3 h-3',
      sm: 'w-4 h-4',
      md: 'w-5 h-5',
      lg: 'w-6 h-6',
      xl: 'w-8 h-8',
      '2xl': 'w-[100px] h-[100px]',
      '3xl': 'w-[115px] h-[115px]',
    },
    color: {
      basic: 'text-black',
      primary: 'text-[var(--blueColor1)]',
      white: 'text-white',
      gray: 'text-[var(--textWhite1)]',
      inherit: 'text-current',
    },
  },
  defaultVariants: {
    size: 'md',
    color: 'inherit',
  },
});

type IconProps = Omit<ReactSVGProps, 'ref' | 'beforeInjection'> &
  VariantProps<typeof icon> & {
    src: string;
    useDefaultColors?: boolean;
  };

const IconCommon = memo(function IconCommon({
  src,
  size,
  color,
  className,
  useDefaultColors = true, // Default to using SVG's original colors
  ...rest
}: IconProps) {
  return (
    <ReactSVG
      src={src}
      beforeInjection={(svg) => {
        svg.setAttribute(
          'class',
          icon({
            size,
            color,
            className,
          }),
        );

        if (!useDefaultColors) {
          svg.querySelectorAll('path').forEach((path) => {
            path.setAttribute('fill', 'currentColor');
          });
        }
      }}
      {...rest}
    />
  );
});
IconCommon.displayName = 'IconCommon';
export default IconCommon;
